import { IFetchConsignee } from './interface';

export class FetchConsigneeList {
  static readonly type = '[Consignee Shared] Fetch Consignee List';
  constructor(
    public payload: IFetchConsignee
  ) { }
}
